<template>
  <div class="photo-wall-card">
    <template>
      <div v-if="edit" class="photo-wall-card__header">
        <button @click="editPhoto()">Edit</button>
        <v-popover :autoHide="true" offset="5" placement="auto-end">
          <i class="fa fa-trash"></i>
          <template slot="popover">
            <div class="confirm-popover-text">Are you sure?</div>
            <div class="confirm-popover-buttons">
              <button class="btn btn-default" v-close-popover>Cancel</button>
              <button class="btn btn-popover-submit" v-close-popover @click="deletePost()">
                Yes, delete
              </button>
            </div>
          </template>
        </v-popover>
      </div>
      <div class="photo-wall-card__body">
        <digital-event-preloader v-if="loading" type="container" :active="loading" />
        <img
          v-show="!loading"
          :key="imageKey"
          :src="item.images[0].imageUrl"
          :alt="'public gallery image' + item.uuid"
          @click="$emit('openGallery')"
          @error="handleErrorImage($event)"
          @load="onImageLoad()"
        />
      </div>
      <div class="photo-wall-card__footer">
        <div class="photo-wall-card__comment">
          <p v-if="item.description.trim()">{{ item.description }}</p>
        </div>
        <person
          v-if="item.userUuid && !myPosts"
          :person="getAuthorById(item.userUuid)"
          :options="{
            hideJob: true,
            popoverContainer: 'body',
            inlineActions: false,
            actions: true,
            hideAdminIcon: true
          }"
        ></person>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Person from "@/components/DigitalEvent/RoomList/Room/People/Person";

export default {
  name: "PhotoWallCard",
  components: {
    person: Person
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    edit: {
      type: Boolean,
      required: false
    },
    index: Number,
    myPosts: Boolean
  },
  data() {
    return {
      loading: false,
      timerId: null,
      imageKey: 0
    };
  },
  computed: {
    ...mapGetters({
      getUser: "users/getUser"
    })
  },
  methods: {
    ...mapActions("photoWall", {
      deleteGalleryPost: "deleteGalleryPost"
    }),
    editPhoto() {
      this.$modal.show("photo-wall-modal", { photo: this.item });
    },
    async deletePost() {
      await this.deleteGalleryPost(this.item);
    },
    getAuthorById(userUUID) {
      return this.getUser(userUUID);
    },
    handleErrorImage() {
      this.loading = true;
      this.timerId = setInterval(() => {
        this.imageKey += 1;
      }, 1000);
    },
    onImageLoad() {
      this.loading = false;
      if (this.timerId) clearInterval(this.timerId);
    }
  }
};
</script>

<style></style>
